export default [
    {
        path: '/license',
        component: () => import('@views/license/index' /* webpackChunkName: "js/license/index" */),
    }
]


// WEBPACK FOOTER //
// resources/js/routers/license.js